export default __webpack_public_path__ + "static/scientist2-157859a9c7f095ecfb1430d547b9c9f8.png";